import React from 'react';
import { useSelector } from 'react-redux';
import { PPSI } from '@ikea-food-ux/ppsi';
import { getOverviewLabels } from '../../../features/app/overviewLabelSelectors';
import { getProductions } from '../../../features/app/productionSelectors';
import { getStockHierarchy } from '../../../features/app/stockHierarchySelectors';
import { getTemperatureUnits } from '../../../features/app/temperatureUnitSelectors';
import { getTimeUnits } from '../../../features/app/timeUnitSelectors';
import { getUtensils } from '../../../features/UtensilContainer/selectors';
import { getLanguage, getConfigs } from '../../../features/app/selectors';
import { stitchPpis } from '../../../utils/ui2pStitchPPI';
import stichPpsi from '../../../utils/ui2pStitchPPSI';
import { EnrichmentData as PpsiEnrichmentData } from '../../../features/PpsiContainer/constants';
import { getGlobalPublishedPpiIfs } from 'features/PpiContainer/selectors';
import { getShelfLifeTimeUnitsUnits } from 'features/app/shelfLifeTimeUnitsSelectors';
// import { getGlobalPublishedPpiIfs } from 'features/PpsiContainer/selectors';

function getPublishedData(ppsi) {
  const data = ppsi.publishedPpsiEnrichmentData;
  const dish = data.referencedIFoodData;
  return {
    ...data,
    ppsiId: ppsi.id,
    dish
  };
}

const GlobalRefrenceTabContent = ({ globalData }) => {
  const language = useSelector(getLanguage);
  const unitSystem = useSelector(getConfigs).toJS().ifoodPPSIUnitSystem;
  const labels = useSelector(getOverviewLabels).toJS();
  const timeUnits = useSelector(getTimeUnits).toJS();
  const temperatureUnits = useSelector(getTemperatureUnits).toJS();
  const stockHierarchy = useSelector(getStockHierarchy).toJS();
  const productionOptions = useSelector(getProductions).toJS();
  const utensils = useSelector(getUtensils).toJS();
  // const [utensils] = useUtensils();
  const globalPpiIfs = useSelector(getGlobalPublishedPpiIfs).toJS();
  const shelfLifeTimeUnits = useSelector(getShelfLifeTimeUnitsUnits).toJS();

  let getGlobalUtensils =
    utensils && utensils.filter(i => i.code.includes('IFS'));

  const { ppiDetails, referencedIFoodData } = globalData[
    PpsiEnrichmentData.PUBLISHED
  ];

  const usedPpis =
    globalPpiIfs &&
    globalPpiIfs
      .filter(
        ppi =>
          ppi.publishedPPIEnrichmentData &&
          ppiDetails
            .map(a => a.ppiEnrichmentDataId)
            .includes(ppi.publishedPPIEnrichmentData.id)
      )
      .map(ppi => ppi.publishedPPIEnrichmentData);

  const publishedData = getPublishedData(globalData);

  const stitchedPpis = stitchPpis(usedPpis);

  const ppsi = stichPpsi(
    publishedData,
    stitchedPpis,
    referencedIFoodData.referencedIngredientEntities,
    'EN-IF'
  );

  const getExcludedItemCodes = ppiDetails
    ? ppiDetails.filter(i => i.ppiNotRequired === true).map(i => i.itemCode)
    : [];

  const ppiWithoutExcludeData = ppsi
    ? ppsi.ppiDetails.filter(i => !getExcludedItemCodes.includes(i.itemCode))
    : [];

  const finalPpsi = {
    ...ppsi,
    ppiDetails: ppiWithoutExcludeData
  };

  if (getGlobalUtensils && finalPpsi) {
    getGlobalUtensils = getGlobalUtensils.map(itm => ({
      ...itm,
      info: { ...itm.info, 'EN-IF': itm.info[language] }
    }));
  }

  return (
    <PPSI
      ppsi={finalPpsi}
      labels={labels}
      timeUnits={timeUnits}
      temperatureUnits={temperatureUnits}
      stockHierarchy={stockHierarchy}
      productionOptions={productionOptions}
      utensils={getGlobalUtensils}
      language="EN-IF"
      navigateIcon="none"
      unitSystem={unitSystem}
      shelfLifeTimeUnits={shelfLifeTimeUnits}
    />
  );
};

export default GlobalRefrenceTabContent;
